import { configureStore } from '@reduxjs/toolkit'
import filterReducer from '../pages/FilterSlice.ts'
import surveyReducer from '../pages/SurveySlice.ts'

export const store = configureStore({
  reducer: {
    filter: filterReducer,
    survey: surveyReducer
  }
})

// Infer the type of `store`
export type AppStore = typeof store
// Infer the `AppDispatch` type from the store itself
export type AppDispatch = typeof store.dispatch
// Same for the `RootState` type
export type RootState = ReturnType<typeof store.getState>